import { useState } from 'react';

export default function useRateSheet() {

    const currentVersion = 1;

    const defaultRateSheetInput = {
        adultPediatric: 'A'
    ,   serviceTypeCategory: null
    ,   serviceType: null
    ,   version: currentVersion
    };

    const getRateSheetInput = () => {

        console.log('loading rate_sheet_input')

        try {
            const rate_sheet_input = JSON.parse(localStorage.getItem('rate_sheet_input'));
            const r = rate_sheet_input  && rate_sheet_input.version && rate_sheet_input.version === currentVersion ? rate_sheet_input : JSON.parse(JSON.stringify(defaultRateSheetInput));
            return r;
        } catch {
            return JSON.parse(JSON.stringify(defaultRateSheetInput))
        }

    };

    const [rateSheetInput, setRateSheetInput4Hook] = useState(getRateSheetInput());

    const setRateSheetInput = (rateSheetInputNew) => {
        rateSheetInputNew['version'] = currentVersion;
        console.log('setting rate_sheet_input');
        localStorage.setItem('rate_sheet_input', JSON.stringify(rateSheetInputNew));
        setRateSheetInput4Hook(rateSheetInputNew);
    };

    const onRateSheetReset = () => {
        localStorage.setItem('rate_sheet_input', JSON.stringify(defaultRateSheetInput));
        setRateSheetInput4Hook(JSON.parse(JSON.stringify(defaultRateSheetInput)));
    };

    return {
        setRateSheetInput
    ,   rateSheetInput
    ,   onRateSheetReset
    ,   currentVersion
    }

}
